import React from 'react';
import { Col, Divider, Row, Space, Tag, Typography } from 'antd';
import { ArticleData, ArticleCategory } from 'models';

import { Link } from 'gatsby';
import ArticleCard from './card';

interface ArticlesProps {
  articles: ArticleData[];
  categories: ArticleCategory[];
}

const Articles: React.FC<ArticlesProps> = ({ articles, categories }) => (
  <Row gutter={{ md: 32, xs: 8, sm: 16 }}>
    <Col md={18} xs={24}>
      {articles.length === 0 && (
        <Typography.Paragraph>
          Il n&#39;y a encore aucun article dans cette catégorie.
        </Typography.Paragraph>
      )}
      <Space direction="vertical" size="large" style={{ width: `100%` }}>
        {articles.map((article: any) => (
          <ArticleCard
            article={article}
            key={`article__left__${article.slug}`}
          />
        ))}
      </Space>
    </Col>
    <Col md={6} xs={24}>
      <Space direction="vertical" size="middle">
        <div>
          <Divider orientation="left">Catégories</Divider>
          {categories.map((cat: any) => (
            <Tag key={cat.slug}>
              <Link to={`/blog/category/${cat.slug}`}>{cat.name}</Link>
            </Tag>
          ))}
        </div>
      </Space>
    </Col>
  </Row>
);

export default Articles;
